export default {_name:'checkbox',module:'Field',view:'Element/Field/Check',options:{xs:12,sm:6},mobileOptions:{ms:6}}